var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuscar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "250 0 800 768",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".buscar_svg__st0{fill:#bebebf}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "buscar_svg__st0",
    d: "M687.6 448.5l109.2 142.2c10.7 13.9 30.5 16.5 44.4 5.8 13.9-10.7 16.5-30.5 5.8-44.4L737.8 409.9c-10.7-13.9-30.5-16.5-44.4-5.8-13.9 10.6-16.5 30.5-5.8 44.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "buscar_svg__st0",
    d: "M746.2 296.6h-26.8c0 14.9-3 28.9-8.4 41.7-8.1 19.2-21.7 35.6-38.8 47.2-17.1 11.6-37.6 18.3-59.9 18.3-14.9 0-28.9-3-41.7-8.4-19.2-8.1-35.6-21.7-47.2-38.8-11.6-17.1-18.3-37.6-18.3-59.9 0-14.9 3-28.9 8.4-41.7 8.1-19.2 21.7-35.6 38.8-47.2 17.1-11.6 37.6-18.3 59.9-18.3 14.9 0 28.9 3 41.7 8.4 19.2 8.1 35.6 21.7 47.2 38.8 11.6 17.1 18.3 37.6 18.3 59.9H773c0-22.1-4.5-43.3-12.6-62.6-12.2-28.9-32.6-53.4-58.2-70.7a160.46 160.46 0 00-89.9-27.5c-22.1 0-43.3 4.5-62.6 12.6-28.9 12.2-53.4 32.6-70.7 58.2a160.46 160.46 0 00-27.5 89.9c0 22.1 4.5 43.3 12.6 62.6 12.2 28.9 32.6 53.4 58.2 70.7 25.6 17.3 56.7 27.5 89.9 27.5 22.1 0 43.3-4.5 62.6-12.6 28.9-12.2 53.4-32.6 70.7-58.2 17.3-25.6 27.5-56.7 27.5-89.9h-26.8z"
  })));
}

export default SvgBuscar;